import React, {useEffect, useRef, useState} from 'react';
import {AppBar, Box, Toolbar} from '@mui/material';
import 'pages/reports/Header/ReportsHeader.css';
import {useNavigate, useNavigation} from 'react-router-dom';
import {logout} from 'lib/utils/loginUtils';
import SearchBarDropdown from "./SearchBarDropdown";
import Button from "@mui/material/Button";
import {ReactComponent as LogoutIcon} from 'assets/icon-logout.svg';
import {ReactComponent as Brand} from 'assets/Brand.svg';

const ReportsHeader = ({vin, setSelectedDatabases}) => {

    const navigate = useNavigate();
    const [isDatabasesSwitchChecked, setIsDatabasesSwitchChecked] = useState(true);
    const [open, setOpen] = useState(false);
    let menuRef = useRef();

    const navigation = useNavigation();

    useEffect(() => {
        let handler = (e) => {
            if (!menuRef?.current?.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => {
            document.removeEventListener('mousedown', handler);
        };
    });

    const onLogoClickHandler = () => {
        navigate('/find-vin');
    };

    const logoutHandler = () => {
        logout();
        navigate('/login');
    };

    return (
        <Box sx={{flexGrow: 1}} className='reportsHeaderContainer'>
            <AppBar className={'navbar'}>
                <Toolbar className='toolbar'>
                    <div className='leftHeaderContainer'>
                        <Brand className={'brandHeader'} onClick={onLogoClickHandler}/>
                        <SearchBarDropdown menuRef={menuRef}
                                           setSelectedDatabases={setSelectedDatabases}
                                           open={open}
                                           setOpen={setOpen}
                                           vin={vin}
                                           navigation={navigation}
                                           isDatabasesSwitchChecked={isDatabasesSwitchChecked}
                                           setIsDatabasesSwitchChecked={setIsDatabasesSwitchChecked}
                        ></SearchBarDropdown>
                    </div>
                    <Button className='logoutButton' onClick={logoutHandler}><LogoutIcon/></Button>
                </Toolbar>
            </AppBar>
        </Box>
    );

};

export default ReportsHeader;